import React from 'react'
import PropTypes from 'prop-types'
import HrbTranslate from '../../language/HrbTranslate';
import Skeleton from '../loaders/Skeleton';
import EmdashText from '../common/EmdashText';

const HorizontalNameValue = props => 
    <div className='level'>
        <div className='level-item horizontal-name-label'>{props.boldText ? <HrbTranslate className='bold-weight bold-horizontal-margin' text={props.textKey} /> : <HrbTranslate className='medium-weight bold-horizontal-margin' text={props.textKey} />}</div>
        {props.values && props.values.map((v, i) =>
            (<div key={`vnv_${i}`} className='p1 medium-weight wrap-anywhere level-right horizontal-name-value-format'>{v}</div>)
        )}
        {props.value && !props.loading && props.boldValue &&
            <div className='p1 bold-weight wrap-anywhere level-right horizontal-name-value-format'>{props.value}</div>
        }
        {props.value && !props.loading && !props.boldValue &&
             <div className='p1 medium-weight wrap-anywhere level-right horizontal-name-value-format'>{props.value}</div> 
        }
        {(!props.value && !props.values) && !props.loading &&
            <div className='p1 medium-weight level-right horizontal-name-value-format'><EmdashText /></div>
        }
        {props.loading &&
            <Skeleton className='level-right horizontal-name-value-format'/>
            }        
    </div>

HorizontalNameValue.propTypes = {
    textKey: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    values: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
    boldText: PropTypes.bool,
    boldValue: PropTypes.bool
}

export default HorizontalNameValue